export enum TrrackEvents {
    TRAVERSAL_START = 'Traversal_Start',
    TRAVERSAL_END = 'Traversal_End',
}
